@if (!organisation.emissionFactors?.length) {
    <p class="empty">There are no emission factors yet. Emission factors turn infrastructure usage, such as litres of diesel or kWh of electricity, into greenhouse gas emissions.</p>
}@else {
    <app-table [columns]="columns" [data]="data" (rowEvent)="handleRowEvent($event)"></app-table>
}
